import dynamic from 'next/dynamic';
import __isEmpty from 'lodash/isEmpty';

const grafics = {
    arcVotsDiputats: dynamic(() => import('./ArcVotsDiputats')),
    arcDiputats: dynamic(() => import('./ArcDiputats')),
    arcVots: dynamic(() => import('./ArcVots')),
    barresVotsDiputats: dynamic(() => import('./BarresVotsDiputats')),
    barresDiputats: dynamic(() => import('./BarresDiputats')),
    barresVots: dynamic(() => import('./BarresVots')),
    lineaEvolucioPartits: dynamic(() => import('./LineaEvolucioPartits')),
    llegenda: dynamic(() =>
        import('components/3catinfo/Eleccions/Grafiques/LlegendaEleccions').then((mod) => mod.LlegendaEleccionsDades)
    )
};

export default function Component(props) {
    const { tipus } = props;
    const Grafic = grafics[tipus];
    if (__isEmpty(Grafic)) return <></>;
    return <Grafic {...props} />;
}
